<mat-form-field class="width" [appearance]="appearance" (click)="onFocus()" [formGroup]="formGroup">

    <mat-label [ngClass]="{'setted': currentCustomer}">
        {{currentLabel}}
    </mat-label>

    <input type="text" [placeholder]=placeholder matInput [matAutocomplete]="auto" formControlName="filter" #inputField (keyup.enter)="setCustomerIfOneLeft()" />
    
    <span class="suffix-wrapper" matSuffix>
        <button @fade [disabled]="filterControl.disabled || !currentCustomer" mat-icon-button color="warn" (click)="selectCustomer(null)"
            matTooltip='Wert leeren'>
            <mat-icon>clear</mat-icon>
        </button>
    </span>

    <mat-autocomplete #auto="matAutocomplete" #autocomplete (optionSelected)="selectCustomer($event)">

        <mat-option class="custom-mat-option" [value]="customer" *ngFor="let customer of customers">
            {{display(customer)|async}}
        </mat-option>

    </mat-autocomplete>

</mat-form-field>

<div *ngIf="currentCustomer && !(currentCustomer.customeractive) && !hideDisabledCustomerHint" class="not-active-hint">

    Dieser Kunde ist nicht aktiv!

</div>
